/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Quick_None_DoneInputs */

const en_us2_workout_quick_none_done = /** @type {(inputs: Workout_Quick_None_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark at least one exercise as done.`)
};

const pt_br2_workout_quick_none_done = /** @type {(inputs: Workout_Quick_None_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marque pelo menos um exercício como feito.`)
};

const es_419_workout_quick_none_done = /** @type {(inputs: Workout_Quick_None_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marca al menos un ejercicio como hecho.`)
};

const pt_pt2_workout_quick_none_done = /** @type {(inputs: Workout_Quick_None_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marca pelo menos um exercício como feito.`)
};

const fr_fr2_workout_quick_none_done = /** @type {(inputs: Workout_Quick_None_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marque au moins un exercice comme fait.`)
};

const de_de2_workout_quick_none_done = /** @type {(inputs: Workout_Quick_None_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Markiere mindestens eine Übung als erledigt.`)
};

const it_it2_workout_quick_none_done = /** @type {(inputs: Workout_Quick_None_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segna almeno un esercizio come fatto.`)
};

/**
* | output |
* | --- |
* | "Mark at least one exercise as done." |
*
* @param {Workout_Quick_None_DoneInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_quick_none_done = /** @type {((inputs?: Workout_Quick_None_DoneInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Quick_None_DoneInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_quick_none_done(inputs)
	if (locale === "es-419") return es_419_workout_quick_none_done(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_quick_none_done(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_quick_none_done(inputs)
	if (locale === "de-DE") return de_de2_workout_quick_none_done(inputs)
	if (locale === "it-IT") return it_it2_workout_quick_none_done(inputs)
	return en_us2_workout_quick_none_done(inputs)
});
export { workout_quick_none_done as "workout-quick.none_done" }